import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ENDPOINTS } from './ENDPOINTS';
import { map, tap } from 'rxjs';
import { getPaginationHeader } from './utils/get-pagination-headers';
import { Client } from '../interfaces/client.interface';
import { User } from '../interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private http = inject(HttpClient);

  all(clinicId: string, params = { page: 1 }) {
    return this.http
      .get<{ count: number; data: Client[] }>(ENDPOINTS.client.all(clinicId), {
        observe: 'response',
        params,
      })
      .pipe(
        map((response) =>
          getPaginationHeader<Client>({
            ...response,
            body: response.body?.data,
          })
        )
      );
  }

  createUser(clinicId: string, body: Partial<Client>) {
    delete body._id;
    return this.http.post<User>(ENDPOINTS.client.create(clinicId), body);
  }
  detailsUser(clientId: string) {
    return this.http.get<Client>(ENDPOINTS.client.details(clientId));
  }
  deleteUser(ids: string[]) {
    return this.http.delete(ENDPOINTS.client.delete, {
      body: {
        ids,
      },
    });
  }
  editUser(clientId: string, body: Partial<Client>) {
    return this.http.put<Client[]>(ENDPOINTS.client.edit(clientId), body);
  }
}
